import { callApi } from "./api";
import { parseBoolean } from "./utils/transforms";
import { normalize, schema } from "normalizr";

const clipartCategory = new schema.Entity('category');
const clipartLimit = new schema.Entity('limit');
//const clipartKeywords = new schema.Entity('keywords');
const clipartCategories = new schema.Array(clipartCategory)
const clipartLimits = new schema.Array(clipartLimit);
const clipartSchema = new schema.Entity('clipart', {
  categories: clipartCategories,
  //keywords: clipartKeywords,
}, {
  mergeStrategy: (entityA, entityB) => {
    let categories = [ ...entityA.categories ]
    entityB.categories.forEach(category => {
      if (entityA.categories.indexOf(category) === -1) {
        categories.push(category)
      }
    })
    return {
      ...entityA,
      ...entityB,
      categories: categories
    }
  }
});

function transformClipArtResponse(response) {
  let cliparts = [];
  response.forEach(function (data) {
    let clipart = {
      id: data.id,
      name: data.name,
      type: data.type,
      url: data.uri,
      designer_art: parseBoolean(data.field_clipart_designer_art),
      double_stamp: parseBoolean(data.field_clipart_double_stamp),
      size_large: data.field_clipart_size_large,
      size_medium: data.field_clipart_size,
      size_small: data.field_clipart_size_small,
      keywords: data.field_keywords.split(",").map((keyword) => keyword.trim()),
      is_active: data.field_clipart_active,
      categories: data.field_category
        .split(",")
        .map((category_id) => category_id.trim()),
      display_weight: parseInt(data.field_display_weight, 10) || 0,
      thumbnail: data.field_thumbnail,
    };
    cliparts.push(clipart);
  });
  return cliparts;
}

function transformClipArtCategoriesResponse(response) {
  let categories = [];
  response.forEach(function (data) {
    let category = {
      id: data.id,
      name: data.name,
      weight: data.weight,
      featured: parseBoolean(data.field_featured_clipart),
      userId: data.field_user_id ? data.field_user_id.split(", ") : [],
    };
    categories.push(category);
  });
  return categories;
}

function transformClipArtLimitsResponse(response)
{
  let limits = []
  response.forEach(function (data) {
    let limit = {
      id: data.tid,
      name: data.name,
      limit: data.field_clipart_limit,
    }
    limits.push(limit)
  })
  return limits
}

export const fetchClipart = () => {
  return callApi("clipart?_format=json").then((response) => {
    if (response.response && response.response.length) {
      let data = transformClipArtResponse(response.response);
      let normalizedData = normalize(data, [clipartSchema]);
      return { response: normalizedData };
    } else {
      return { response: {} };
    }
  });
};

export const fetchClipartCategories = () => {
  return callApi('clipartcategories?_format=json').then((response) => {
    if (response.response && response.response.length) {
      let data = transformClipArtCategoriesResponse(response.response);
      let normalizedData = normalize(data, clipartCategories);
      return { response: normalizedData };
    } else {
      return { response: {} };
    }
  })
}

export const fetchClipartLimits = () => {
  return callApi('product_type_settings?_format=json').then((response) => {

    if (response.response && response.response.length) {
      let data = transformClipArtLimitsResponse(response.response)
      let normalizedData = normalize(data, clipartLimits);
      return {response: normalizedData}
    } else {
      return {response: {}}
    }
  })
}
